// Get all the options for the dropdown menu
export const getDropDownOptions = (SectionZone) =>
  SectionZone?.map((zone) => ({
    key: zone.ZoneId,
    name: `${zone.Description} (${zone.PriceRange})`,
  }));

// Add the Error message to the DOM with vanilla JS
export const addErrorMessageToPage = (errorText) => {
  const errorContainer = document.getElementById('requestSeatsError');
  errorContainer.style.display = 'block';
  errorContainer.innerHTML = `<p>${errorText}</p>`;
};

// Get the total number of seats selected for all price types
export const getTotalSeatsSelected = (seatsSelected) =>
  seatsSelected.reduce((totalNumOfSeats, currentSeat) => totalNumOfSeats + currentSeat.NumSeats, 0);

// Get the current seat which is being rendered in the loop
export const getCurrentSeat = (seatsSelected, PriceTypeId) =>
  seatsSelected.find((seatType) => seatType.PriceTypeId === PriceTypeId);

// Figure out when the max tickets are reach so that the InputNumber is disabled
export const calculateMaxTicketsReached = (
  currentSeat,
  priceType,
  operandIncrement,
  totalSeatsSelected,
  MaxTicketsPerOrder
) => {
  const maximumReached = Boolean(priceType.TicketMaximum) && currentSeat?.NumSeats >= priceType.TicketMaximum;
  const preventIncrement = totalSeatsSelected + operandIncrement > MaxTicketsPerOrder;
  return maximumReached || preventIncrement;
};

// Figure out how many tickets to add/subtract with a click of the plus/minus on the InputNumber
export const calculateInputOperands = (priceType, currentSeat) => {
  let operandDecrement = priceType.TicketMultiple || 1;
  let operandIncrement = priceType.TicketMultiple || 1;
  const ticketMaximum = priceType.TicketMaximum || Infinity;
  const isTicketSelected = Boolean(currentSeat) && Boolean(currentSeat.NumSeats);

  if (isTicketSelected) {
    const isTicketBelowMinimum = currentSeat.NumSeats < priceType.TicketMinimum;
    const willIncrementOverflow = currentSeat.NumSeats + operandIncrement > ticketMaximum;
    const willDecrementUnderflow = currentSeat.NumSeats - operandDecrement < priceType.TicketMinimum;

    if (isTicketBelowMinimum) {
      operandIncrement = priceType.TicketMinimum - currentSeat.NumSeats;
      operandDecrement = currentSeat.NumSeats;
    }
    if (willIncrementOverflow) {
      operandIncrement = ticketMaximum - currentSeat.NumSeats;
    }
    if (willDecrementUnderflow) {
      const willDecrementToMinimum = currentSeat.NumSeats > priceType.TicketMinimum;
      if (willDecrementToMinimum) {
        operandDecrement = currentSeat.NumSeats - priceType.TicketMinimum;
      } else {
        operandDecrement = currentSeat.NumSeats;
      }
    }
  } else {
    operandIncrement = priceType.TicketMinimum || Math.min(operandIncrement, ticketMaximum);
    operandDecrement = 0;
  }

  return {
    operandIncrement,
    operandDecrement,
  };
};
